import { ca } from '@cian/analytics';
import { EServiceId } from '../../../shared/redux/reducers';
import { TAnalyticsOfferStatus } from '../../../shared/types/analytics';

interface ITrackServicesShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  serviceIds: Array<EServiceId>;
  analyticsFormId: string;
  deviceType: string;
}

export const trackServicesShow = (params: ITrackServicesShowParams) => {
  const { analyticsOfferStatus, serviceIds, analyticsFormId, deviceType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show',
    label: serviceIds.join('/'),
    page: {
      pageType: 'AddForm',
      siteType: deviceType,
      extra: {
        type: 'fvu_old',
        form_id: analyticsFormId,
      },
    },
  });
};

interface ITrackDiffPricingShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsFormId: string;
  diffPriceIterationId: string | null;
  diffPriceGranuleGuid: string | null;
}

export const trackDiffPricingShow = (params: ITrackDiffPricingShowParams) => {
  const { analyticsOfferStatus, analyticsFormId, diffPriceIterationId, diffPriceGranuleGuid } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'show_diff_pricing',
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        form_id: analyticsFormId,
        diffPriceGranuleGuid,
        diffPriceIterationId,
      },
    },
  });
};
